<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

var data = {

  name: ['小麦', '玉米', '大豆'],
  value1: [585.6, 650.1, 188.2]
}



// 创建ECharts配置对象
const option = {
  // backgroundColor: '#394056',
  title: {
    text: "",
    left: 'center',
    top: 18,
    textStyle: {
      color: '#fff',
      fontWeight: 'normal',
      fontSize: 20
    }
  },
  legend: { // 图示例样式
    show: true,
    top: 50,
    right: 50,
    itemGap: 20,
    textStyle: {
      color: '#fff',
    },
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: { // 坐标轴指示器，坐标轴触发有效
      type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
    }
  },
  grid: {
    top: "16%",
    left: '8%',
    right: '8%',
    bottom: '8%',
    containLabel: true,
  },
  xAxis: [{
    type: 'category',
    data: data.name,
    axisTick: {
      // 其他可选属性，如对齐方式等
      alignWithLabel: true // 刻度线是否与标签对齐，默认false
    },
    axisLabel: {
      padding: [3, 0, 0, 0],
      formatter: '{value}',
      color: '',
      textStyle: {
        fontSize: 14,
        color: '#fff'
      },
    },
    // 设置 X 轴线条粗细
    axisLine: {
      lineStyle: {
        width: 1, // 根据需求调整数值大小，单位是像素
        color: '#999',
      }
    }
  }],
  yAxis: [{
    type: 'value',
    name: '亩产(公斤)',
    nameTextStyle: {
      color: "#fff",
      fontSize: 16,

    },
    axisLabel: {
      padding: [3, 0, 0, 0],
      formatter: '{value}',
      color: '#fff',
      textStyle: {
        fontSize: 14,
        color: '#fff'
      },
    },
    axisTick: {
      show: false, // 默认为true，如果要隐藏，则改为 false

    },
    axisLine: {
      show: true,
      lineStyle: {
        width: 1,
        color: '#999',
      },
    },
    splitLine: {
      lineStyle: {
        width: 1,
        color: '#394458',
      },
    },
  }],
  series: [{
    data: data.value1,
    type: 'bar',
    barWidth: 30, // 根据需求调整数值大小，单位是像素
    itemStyle: {
      color: '#077F60',
    }
  }],
  // 添加点击事件的处理函数
  // emphasis: {
  //   itemStyle: {
  //     color: '#077F60',
  //     barWidth: 20, // 根据需求调整数值大小，单位是像素
  //   },
  //   barWidth: 24, // 根据需求调整数值大小，单位是像素
  // },

};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
